import { Table } from '@billy/design-system'
import { ReactElement } from 'react'

import { TableIds } from '../../../../../../enums/tableIds'
import { useSalesByItemReport } from '../../../../hooks/salesByItemReport/useSalesByItemReport'
import { useSalesByItemReportTableColumns } from '../../../../hooks/salesByItemReport/useSalesByItemReportTableColumns'
import { useSalesByItemReportTableData } from '../../../../hooks/salesByItemReport/useSalesByItemReportTableData'

export const SalesByItemReportTable = (): ReactElement => {
  const { isLoading } = useSalesByItemReport()
  const tableData = useSalesByItemReportTableData()
  const tableColumns = useSalesByItemReportTableColumns()

  return (
    <Table
      columns={tableColumns}
      data={tableData}
      id={TableIds.SalesByItemReport}
      isLoading={isLoading}
      withColumnsFiltering={false}
      withFooter
      withPagination={false}
      withSkeletonView
      withStickyHeader
    />
  )
}
